import lazyRetry from './lazyLoader';
import MainLayout from 'layout/MainLayout.tsx';
import Lazy from 'components/Lazy.tsx';
import { lazy } from 'react';
import ProjectWorkflowsRoutes from './ProjectWorkflowsRoutes.tsx';
import ProjectWorkflowExecutionsRoutes from './ProjectWorkflowExecutionRoutes.tsx';
import ProjectCanvasRoutes from './ProjectCanvasRoutes.tsx';

const HomeView = Lazy(lazy(() => lazyRetry(() => import('views/home/HomeView.tsx'))));
const ProjectsView = Lazy(lazy(() => lazyRetry(() => import('views/projects/ProjectsView.tsx'))));
const ProjectAddView = Lazy(lazy(() => lazyRetry(() => import('views/projects/ProjectAdd.tsx'))));
const ProjectEditView = Lazy(lazy(() => lazyRetry(() => import('views/projects/ProjectEdit.tsx'))));

const ProjectsRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <HomeView />,
    },
    {
      path: '/projects',
      element: <ProjectsView />,
    },
    {
      path: '/projects/add',
      element: <ProjectAddView />,
    },
    {
      path: '/projects/edit/:projectId',
      element: <ProjectEditView />,
    },
    {
      path: '/projects/:projectId',
      children: [ProjectWorkflowsRoutes, ProjectWorkflowExecutionsRoutes, ProjectCanvasRoutes],
    },
  ],
};

export default ProjectsRoutes;
